export default __webpack_public_path__ + "static/media/pilot-blue.57c04867.png";